<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <h5 class="grey--text">Vista general</h5>
    <v-row>
        <v-col md="6">
            <h2 class="deep-purple--text lighten-3">{{$t('students.all_students')}}</h2>
        </v-col>
        <v-col md="6">
            <v-row justify="end" class="my-0 mr-4">
              <v-btn text small color="deep-purple lighten-1" @click.prevent="toggleCreateStudentModal()">
                <v-icon size="21" class="mr-1">
                  mdi-plus
                </v-icon>
                {{ $t('students.create') }}
              </v-btn>
              <v-btn v-if="isAdmin && independentEnabled" text small color="deep-purple lighten-1"
                     @click.prevent="toggleCreateIndependentModal()">
                <v-icon size="21" class="mr-1">mdi-account-plus-outline</v-icon>
                {{ $t('students.create_independent') }}
              </v-btn>
            </v-row>
        </v-col>
    </v-row>
    <students-filter v-model="params" @search="search(true)"></students-filter>
    <students-data-table :table-loading="loading" v-model="page" :items="students"
                         :length="totalPages"></students-data-table>
    <create-student-modal
      v-model="isCreateStudentModalOpen"
      @onCancel="toggleCreateStudentModal"
      :isStudent="true"
    />
    <create-independent-student-modal
      v-if="isAdmin && independentEnabled && isCreateIndependentModalOpen"
      v-model="isCreateIndependentModalOpen"
      @onCancel="toggleCreateIndependentModal"
      @onSave="search()"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CreateStudentModal from '@/components/students/modals/CreateStudentModal.vue';
import CreateIndependentStudentModal from '@/components/students/modals/CreateIndependentStudentModal.vue';
import USER_ROLES from '@/utils/user';
import StudentsFilter from '../../components/core/filters/StudentsFilter.vue';
import StudentsDataTable from '../../components/students/StudentsDataTable.vue';
import LoadingMixin from '../../mixins/loading';

import userService from '../../services/user.service';
import { defaultStudentFilter } from '../../constants/filters';
import { buildStudentSearchParams, INDEPENDENT_STUDENTS_ENABLED } from '../../utils/independentStudents';

export default {
  name: 'Students',
  components: {
    StudentsFilter,
    StudentsDataTable,
    CreateStudentModal,
    CreateIndependentStudentModal,
  },
  data: () => ({
    page: 1,
    params: { ...defaultStudentFilter },
    isCreateStudentModalOpen: false,
    isCreateIndependentModalOpen: false,
    independentEnabled: INDEPENDENT_STUDENTS_ENABLED,
  }),
  async mounted() {
    await this.search();
  },
  computed: {
    ...mapState({
      students: ({ enrollment: { students } }) => students,
      totalPages: ({ enrollment: { totalPages } }) => totalPages,
      currentUser: ({ currentUser }) => currentUser,
    }),
    isAdmin() {
      return !!this.currentUser?.roles?.includes(USER_ROLES.ADMIN);
    },
  },
  methods: {
    ...mapActions('enrollment', ['setStudentDataTable']),
    async search(reset = false) {
      this.loader();
      if (reset) this.page = 1;
      const {
        data: {
          data,
          total_page: totalPages,
        },
        status,
      } = await userService.findAllByParameters(this.page, buildStudentSearchParams(this.params));
      if (status === 200) {
        this.setStudentDataTable({ data, totalPages });
      }
      this.loader();
    },
    toggleCreateStudentModal() {
      this.isCreateStudentModalOpen = !this.isCreateStudentModalOpen;
    },
    toggleCreateIndependentModal() {
      this.isCreateIndependentModalOpen = !this.isCreateIndependentModalOpen;
    },
  },
  watch: {
    page() {
      this.search();
    },
  },
  mixins: [LoadingMixin],
};
</script>
